import { addYears } from "date-fns";
import * as yup from "yup";

import { Shape } from "@/core/yup";
import i18n from "@/i18n";
import { validateBCE, validateUnitEstablishNumber } from "@/validations";

import { CompanyFormType } from "../../formType";
import { CompanyGeneralFormType } from "./formType";

export const nameMaxLength = 35;
export const amoutMinMax = { min: 0, max: 100000 };

export const formSchemaGeneral = yup.object<{}, Shape<CompanyGeneralFormType>>({
    name: yup.string().max(nameMaxLength).required(),
    legalForm: yup.string().required(),
    language: yup.string().required(),
    nationality: yup.string().required(),
    enterpriseNumber: yup
        .string()
        .test("enterpriseNumber", i18n.t("Validations.Format"), function testEnterpriseNumber() {
            const { enterpriseNumber } = this.parent;
            return validateBCE(enterpriseNumber);
        }),
    establishmentNumber: yup
        .string()
        .test("establishmentNumber", i18n.t("Validations.Format"), function testEstablishmentNumber() {
            const { establishmentNumber } = this.parent;
            return validateUnitEstablishNumber(establishmentNumber);
        }),
    nssoRegistrationNumber: yup.string().max(12),
    foundationDate: yup.date().min(new Date(1900, 0, 1)).max(addYears(new Date(), 100)).nullable(),
    lastStatuteChangeDate: yup.date().nullable(),
    amountOfStaff: yup.number().amount(amoutMinMax).nullable(),
    amountOfEmployees: yup.number().amount(amoutMinMax).nullable(),
    amountOfWorkers: yup.number().amount(amoutMinMax).nullable(),
});

export const formSchemaGeneralStep = yup.object<{}, Shape<CompanyFormType>>({
    general: formSchemaGeneral,
});
